import React from "react";
import Box from "react-raster";
import { getImage, GatsbyImage } from "gatsby-plugin-image";
import styled from "styled-components";
import Container from "../Container";
import { H2, Blockquote, Eyebrow, AccentTitle } from "../Typography";

const StyledContainer = styled(Container)``;

const Reference = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.colours.lightestGray};

  @media (${({ theme }) => theme.mq.l}) {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
`;

const ReferenceItem = styled.div`
  a {
    color: ${({ theme }) => theme.colours.lightGrey};
    text-decoration: none;
    &:hover {
      color: ${({ theme }) => theme.colours.grey};
    }
  }

  @media (${({ theme }) => theme.mq.l}) {
    margin-left: 20px;
  }
`;

const Content = styled.div`
  display: ${({ isVerticallyCentered }) => isVerticallyCentered && "flex"};
  flex-direction: column;
  justify-content: center;
  @media (${({ theme }) => theme.mq.l}) {
    min-height: 260px;
  }
  margin-top: 30px;

  @media (${({ theme }) => theme.mq.l}) {
    margin-top: 0;
  }
`;

const Title = styled.div`
  margin-bottom: 30px;
`;

const BlockquoteContainer = styled.div`
  margin-left: 30px;

  @media (${({ theme }) => theme.mq.l}) {
    margin-left: 0;
  }
`;

const FullWidthWrapper = styled.div`
  width: 100%;
  padding-bottom: ${({ $hasBottomMargin }) =>
    $hasBottomMargin ? "60px" : "20px"};
  padding-top: ${({ $hasTopMargin }) => ($hasTopMargin ? "60px" : "20px")};
`;

function HasImage({
  referenceDate,
  dateLabel,
  referenceTitle,
  referenceTitleLabel,
  referenceUrl,
  eyebrow,
  title,
  name,
  position,
  image,
  quote,
  logo,
  layout = "narrow",
  imagePosition = "left",
  hasBottomMargin,
  hasTopMargin,
}) {
  // TODO: factory functions for these
  const isWide = layout === "wide";
  const imageColumnCols = [6, 12, isWide ? 4 : 5];
  const imageColumnLeft =
    isWide && imagePosition === "right"
      ? [0, 0, 1]
      : [0, 0, imagePosition === "left" && !isWide ? 1 : 0];

  const contentColumnCols = [6, 12, isWide ? 6 : 4];
  const contentColumnLeft = [0, 0, 1];

  return (
    <FullWidthWrapper
      $hasBottomMargin={hasBottomMargin}
      $hasTopMargin={hasTopMargin}
    >
      <StyledContainer
        alignItems="center"
        paddingLeft={
          isWide && imagePosition !== "right" ? ["30px", "30px", "0"] : "30px"
        }
        paddingRight={
          isWide && imagePosition !== "left" ? ["30px", "30px", "0"] : "30px"
        }
      >
        <Box
          cols={imageColumnCols}
          marginLeft={imageColumnLeft}
          styles={{ order: imagePosition === "right" ? 2 : undefined }}
        >
          {image && <GatsbyImage image={getImage(image)} />}
        </Box>
        <Box
          cols={contentColumnCols}
          marginLeft={contentColumnLeft}
          height={referenceTitle && "100%"}
          styles={{ order: imagePosition === "right" ? 1 : undefined }}
        >
          {referenceTitle && (
            <Reference>
              {logo?.fixed && (
                <img {...logo.fixed} alt={logo.description || "logo"} />
              )}
              <ReferenceItem>
                <AccentTitle marginTop="0">{dateLabel}</AccentTitle>
                <Eyebrow colour="lightGrey">{referenceDate}</Eyebrow>
              </ReferenceItem>
              <ReferenceItem>
                <AccentTitle marginTop="0">{referenceTitleLabel}</AccentTitle>
                <Eyebrow colour="lightGrey">
                  <a href={referenceUrl}>{referenceTitle}</a>
                </Eyebrow>
              </ReferenceItem>
            </Reference>
          )}

          <Content isVerticallyCentered={referenceTitle}>
            {!referenceTitle && (
              <Title>
                <Eyebrow colour="purple">{eyebrow}</Eyebrow>
                <H2>{title}</H2>
              </Title>
            )}
            <BlockquoteContainer>
              <Blockquote>{quote}</Blockquote>
            </BlockquoteContainer>
            {name && <AccentTitle>{name}</AccentTitle>}
            {position && (
              <Eyebrow colour="lightGrey" decorated={false}>
                {position}
              </Eyebrow>
            )}
          </Content>
        </Box>
      </StyledContainer>
    </FullWidthWrapper>
  );
}

export default HasImage;
